import {
  AddCompanyResponse,
  CompanyCommonResponse,
  CompanyError,
  CompanyItem,
  CompanyResponse,
  DeletedCompany,
} from '@core/interface/company';
import { PagePayload } from '@core/interface/core';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const CompanyActions = createActionGroup({
  source: 'Company',
  events: {
    'Load Companies': props<PagePayload>(),
    'Load Companies Success': props<CompanyResponse>(),
    'Load Companies Failure': props<CompanyError>(),
    'Add Edit Company': props<CompanyItem>(),
    'Add Company Success': props<AddCompanyResponse>(),
    'Update Company Success': props<AddCompanyResponse>(),
    'Add Company Failure': props<CompanyError>(),
    'Update Company Failure': props<CompanyError>(),
    'Delete Company': props<{ id: number }>(),
    'Delete Company Success': props<DeletedCompany>(),
    'Delete Company Failure': props<CompanyError>(),
    'Reset Delete Status': emptyProps(),
    'Reset Companies': emptyProps(),
  },
});
